"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroShowcase() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section id="hero-showcase" className="relative w-full min-h-screen flex items-center justify-center py-40 overflow-hidden bg-background !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/IDIA6838.jpg)]">
      {}
      <div className="absolute inset-0 w-full h-full z-0">
        {}
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/IDIA6838.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/IDIA6838.jpg-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/IDIA6838.jpg-wvc-sizes" alt="Palomino Coastline" className="absolute inset-0 w-full h-full object-cover object-center saturate-50" loading="lazy" decoding="async" />
        {}
        <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover object-center saturate-50">
          <source src="https://cdn.coverr.co/videos/coverr-waves-crashing-on-the-beach-5264/1080p.mp4" type="video/mp4" />
        </video>
      </div>

      {}
      {}
      <div className="absolute inset-0 z-0 bg-[radial-gradient(circle_at_center,transparent_0%,rgba(20,20,22,0.65)_100%)]"></div>
      
      {}
      <div className="absolute inset-0 z-0 opacity-[0.04] mix-blend-overlay pointer-events-none bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MDAiIGhlaWdodD0iNDAwIj48ZmlsdGVyIGlkPSJub2lzZSI+PGZlVHVyYnVsZW5jZSB0eXBlPSJmcmFjdGFsTm9pc2UiIGJhc2VGcmVxdWVuY3k9IjAuNjUiIG51bU9jdGF2ZXM9IjMiIHN0aXRjaFRpbGVzPSJzdGl0Y2giLz48L2ZpbHRlcj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWx0ZXI9InVybCgibm9pc2UpIi8+PC9zdmc+')]"></div>

      {}
      <div ref={ref} className={`relative z-10 flex flex-col items-center text-center px-6 max-w-5xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <h1 className="font-default font-light text-secondary text-6xl md:text-8xl leading-[1.1] tracking-tight">Palomino</h1>
        
        <p className="mt-8 font-sans text-background text-lg md:text-xl max-w-2xl font-light tracking-wide"><br /></p>
        
        <div className="mt-14">
          <Button asChild size="lg" className="rounded-sm bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-xl hover:shadow-primary/30 transition-all duration-500 px-10 py-7 text-lg font-medium border-none">
            
          </Button>
        </div>
      </div>
    </section>;
}